/**
 * API Endpoints Constants
 * Centralized definition of all API endpoints
 */

export const API_ENDPOINTS = {
    // Account endpoints
    ACCOUNT: {
        LOGIN: '/account/login',
        PROFILE: '/account',
        DEBTOR_REGISTRATION: '/account/DEBTOR',
        VALIDATE_TOKEN: '/account/validate-token',
        SET_PASSWORD: '/account/set-password'
    },

    // Debtor endpoints
    DEBTOR: {
        PROFILE: '/debtor',
        INVOICES: '/debtor/invoices',
        INVOICE_DETAIL: (id: string) => `/debtor/invoices/${id}`,
        PUBLISH_INVOICES: '/debtor/invoices/publish',
        DELETE_INVOICES: '/debtor/invoices',
        UPLOAD_INVOICES: '/debtor/invoices/upload',
        DOCUMENTS: '/debtor/documents',
        DOCUMENT_VIEW: (id: string) => `/debtor/documents/${id}/view`,
        DOCUMENT_DOWNLOAD: (id: string) => `/debtor/documents/${id}/download`,
        DOCUMENT_UPLOAD: '/debtor/documents',
        DOCUMENT_REPLACE: (id: string) => `/debtor/documents/${id}`,
        CONTRACTS: '/debtor/contracts',
        CONTRACT_SIGN: (id: string) => `/debtor/contracts/${id}/sign`,
        ACCOUNT_STATEMENT: '/debtor/account-statement',
        ACCOUNT_STATEMENT_EXPORT: '/debtor/account-statement/export',
        SELLERS: '/debtor/sellers'
    }
} as const;

/**
 * Helper function to build full API URLs
 */
export const buildApiUrl = (endpoint: string): string => {
    return endpoint;
};
